/**
 * Get the phone number to display for an appointment.
 * Prioritizes bookingPhone (phone used during booking), falls back to customer's phone numbers.
 * Returns a phone object with id, phone, and label properties.
 */
export function getDisplayPhone<
  T extends { id: string; phone: string; label?: string | null } | null | undefined,
>(
  bookingPhone: T,
  phoneNumbers?: Array<{
    id: string;
    phone: string;
    label?: string | null;
    isPrimary?: boolean;
  }> | null
): T {
  if (bookingPhone) {
    return bookingPhone;
  }

  // Try to find primary phone first, otherwise use the first phone
  const primaryPhone = phoneNumbers?.find((p) => p.isPrimary === true);
  const fallbackPhone = primaryPhone || phoneNumbers?.[0];

  return fallbackPhone as T;
}
